var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DeviceLayout',{attrs:{"preview-data":{ name: _vm.previewNameLang, type: 'HouseConsumption' },"device-icon":"house-consumption","is-preview":true},scopedSlots:_vm._u([{key:"basic-controls",fn:function(){return [_c('div',{staticClass:"d-flex house-consumption"},[_c('div',[_vm._v("2,11 kW")])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }